import Colors from '../../../../shared/assets/style/default/color';
import Fonts from '../../../../shared/assets/style/default/fonts';
import styled from 'styled-components';
import Screen from '../../../../shared/utils/screen';

const NetworkDescription = styled.div<React.CSSProperties>`
  color: ${Colors['light']};
  font-family: ${Fonts['light']};
  font-size: ${Screen.widthRatio * 44}px;
  top: ${Screen.widthRatio * 550}px;
  width: ${Screen.widthRatio * 1300}px;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
`;

export default NetworkDescription;
